import React, { useState, useEffect } from "react";
import WorkerModal from "./WorkerModal";
import bot_img from "../../assets/img/chatbot-img.png";
import PropTypes from "prop-types";
import Switch from "react-switch";
import { ImSpinner8 } from "react-icons/im";
import {
  createWorkerAction,
  deleteWorkerAction,
  fetchWorkersAction,
  switchWorkerStatusAction,
  updateWorkerAction,
} from "../../store/worker/workerThunk";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getCookie } from "cookies-next";

export default function WorkerTable({ color }) {
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(null);
  const [selectedChatbot, setSelectedChatbot] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const dispatch = useDispatch();

  const { workers } = useSelector((state) => state?.worker);
  const role = getCookie("user");

  useEffect(() => {
    dispatch(fetchWorkersAction());
  }, [dispatch]);

  const toggle = () => setModal(!modal);

  // const handleAddChatbot = (chatbot) => {
  //   setIsLoading(true);
  //   dispatch(
  //     createWorkerAction({
  //       Name: chatbot.name,
  //       Behaviour: chatbot.behaviour,
  //       onSuccess: () => {
  //         toggle();
  //         setIsLoading(false);
  //       },
  //       onError: (error) => {
  //         console.error(error);
  //         setIsLoading(false);
  //       },
  //     })
  //   );
  // };

  const handleEdit = (index) => {
    setSelectedChatbot(index);
    setEditMode(true);
    toggle();
  };

  // const handleUpdate = (chatbot) => {
  //   setIsLoading(true);
  //   dispatch(
  //     updateWorkerAction({
  //       Id: chatbot?.id,
  //       Name: chatbot?.name,
  //       Behaviour: chatbot?.behaviour,
  //       Status: chatbot?.status,
  //       onSuccess: () => {
  //         toggle();
  //         setIsLoading(false);
  //       },
  //       onError: (error) => {
  //         console.error(error);
  //         setIsLoading(false);
  //       },
  //     })
  //   );
  // };

  const handleDelete = (workerId) => {
    setLoadingDelete(workerId);
    setIsLoading(true);

    dispatch(
      deleteWorkerAction({
        Id: workerId,
        onSuccess: () => {
          console.log(`Chatbot ${workerId} deleted successfully`);
          setLoadingDelete(null);
          setIsLoading(false);
          dispatch(fetchWorkersAction());
        },
        onError: (error) => {
          console.error("Error deleting Chatbot:", error);
          // Ensure the toast is directly called here for testing
          //toast.error(error);
          setLoadingDelete(null);
          setIsLoading(false);
        },
      })
    );
  };

  const handleToggleStatus = (worker) => {
    console.log(worker, "Chatbot in toggle status");
    dispatch(
      switchWorkerStatusAction({
        id: worker.id,

        onSuccess: () => {
          console.log(`Chatbot ${worker.id} status switched`);
          dispatch(fetchWorkersAction());
        },
        onError: (error) => {
          console.error("Error switching chatbot status:", error);
        },
      })
    );
  };

  const truncateText = (text, maxChars) => {
    if (text && text.length > maxChars) {
      return text.substring(0, maxChars) + "...";
    }
    return text;
  };

  return (
    <>
      <div className="worker_main_container">
        <div className="flex justify-end">
          <button
            className="button_worker"
            onClick={() => {
              setEditMode(false);
              toggle();
            }}
            disabled={isLoading}
          >
            Add Chatbot
          </button>
        </div>

        <div className="card-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
          {workers?.length > 0 ? (
            workers.map((chatbot, index) => (
              <div
                key={chatbot?.id || index}
                className="card h-[320px] w-[250px] bg-white shadow-md rounded-lg p-4 flex flex-col justify-between"
              >
                <div className="flex justify-between pb-3">
                  <Switch
                    checked={chatbot?.status === "Active"}
                    onChange={() => handleToggleStatus(chatbot)}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#86d3ff"
                    offColor="#ff5c5c"
                  />
                  {chatbot?.status === "Active" ? (
                    <p className="bg-green-400 rounded-[12px] px-[12px] py-[3px] text-white text-[12px] ml-2">
                      {chatbot?.status}
                    </p>
                  ) : (
                    <p className="bg-red-400 rounded-[12px] px-[12px] py-[3px] text-white text-[12px] ml-2">
                      {chatbot?.status}
                    </p>
                  )}
                </div>
                <div className="card-header flex-grow flex flex-col items-center justify-center">
                  <div className="bot-img flex justify-center mb-4">
                    <img
                      src={bot_img || "/default-bot.png"}
                      className="h-24 w-24"
                      alt={chatbot?.name || "Default Bot"}
                    />
                  </div>
                  <div className="flex flex-col gap-2 items-center text-center">
                    <p className="font-semibold text-base text-nowrap truncate max-w-44">
                      {chatbot?.name || "No Name Provided"}
                    </p>
                    <p className="text-gray-600">
                      {truncateText(chatbot?.behaviour || "No Description", 10)}
                    </p>
                  </div>
                </div>
                <div
                  className={`flex ${
                    role == "admin" ? "justify-end" : "justify-between"
                  } gap-4 mt-4`}
                >
                  <button
                    className="flex items-center justify-center gap-2 w-[50%] bg-blue-500 rounded-lg text-center text-white px-4 py-2 hover:bg-blue-700"
                    onClick={() => handleEdit(index)}
                  >
                    Edit
                  </button>
                  {role !== "admin" && (
                    <button
                      className="flex items-center justify-center gap-2 w-[50%] bg-red-500 rounded-lg text-center text-white px-4 py-2 hover:bg-red-700"
                      onClick={() => handleDelete(chatbot?.id)}
                      disabled={isLoading && loadingDelete === chatbot?.id}
                    >
                      {isLoading && loadingDelete === chatbot?.id ? (
                        <ImSpinner8 className="animate-spin" />
                      ) : (
                        "Delete"
                      )}
                    </button>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center mt-4">
              No chatbots available.
            </p>
          )}
        </div>
      </div>
      <WorkerModal
        isOpen={modal}
        toggle={toggle}
        // onSubmit={editMode ? handleUpdate : handleAddChatbot}
        editMode={editMode}
        chatbot={editMode ? workers[selectedChatbot] : null}
      />
    </>
  );
}

WorkerTable.defaultProps = {
  color: "light",
};

WorkerTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
